module.exports = __webpack_public_path__ + "img/theme16.2a3595f1.png";